import React, { Component } from 'react';
import { Switch, Redirect, withRouter, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import 'tachyons';

import Layout from './app/common/Layout/Layout';
import Home from './app/home/Home';
import News from './app/news/News';
import Reviews from './app/reviews/Reviews';
import SingleArticle from './app/single-article/SingleArticle';
import ReviewsSubCategory from './app/reviews/reviewsSubCategory';
import T3 from './app/how-to-(T3)/T3';
import Internet from './app/internet/Internet';
import BestOf from './app/best-of/BestOf';
import Author from './app/author/Author';
import Tags from './app/tags/Tags';
import Gallery from './app/gallery/Gallery';
import { About, ContactUs, TnC, Careers, Advertise } from './app/static-pages';
import OldGallery from './app/gallery/OldGallery';
import Search from './app/common/Search/Search';

class App extends Component {
  render() {
    let routes = (
      <Switch>
        <Route path="/" exact strict component={Home} />
        <Route path="/news" exact strict component={News} />
        <Route path="/reviews" exact strict component={Reviews} />
        <Route
          path="/reviews/laptops"
          exact
          strict
          component={ReviewsSubCategory}
        />
        <Route
          path="/reviews/mobiles"
          exact
          strict
          component={ReviewsSubCategory}
        />
        <Route
          path="/reviews/cameras"
          exact
          strict
          component={ReviewsSubCategory}
        />
        <Route
          path="/reviews/accessories"
          exact
          strict
          component={ReviewsSubCategory}
        />
        <Route path="/old-gallery" exact strict component={OldGallery} />
        <Route path="/how-to" exact strict component={T3} />
        <Route path="/internet" exact strict component={Internet} />
        <Route path="/best-of" exact strict component={BestOf} />
        <Route path="/author/:authorName" component={Author} />
        <Route path="/about" exact strict component={About} />
        <Route path="/contact-us" exact strict component={ContactUs} />
        <Route path="/terms-and-conditions" exact strict component={TnC} />
        <Route path="/careers" exact strict component={Careers} />
        <Route path="/advertise" exact strict component={Advertise} />
        <Route path="/tags/:tagName" exact strict component={Tags} />
        <Route
          path={`/search/results/:query?`}
          exact
          strict
          component={Search}
        />

        <Route path="/:slug" exact strict component={SingleArticle} />

        <Switch>
          <Route
            path="/gallery/:slug/:index?"
            exact
            strict
            component={Gallery}
          />
          {/* <Redirect to="/gallery/:slug/0" exact strict component={Gallery} /> */}
        </Switch>

        {/* <Route path="/" component={SingleArticle} /> */}
        <Redirect to="/" />
      </Switch>
    );

    return (
      <div className="App">
        <Layout> {routes}</Layout>
      </div>
    );
  }
}

export default withRouter(connect(null)(App));
